export var Events;
(function (Events) {
    Events["SegmentLoaded"] = "segment_loaded";
    Events["SegmentError"] = "segment_error";
    Events["SegmentAbort"] = "segment_abort";
    Events["SegmentDownloaded"] = "segment_downloaded";
    Events["PeerConnect"] = "peer_connect";
    Events["PeerClose"] = "peer_close";
    Events["PieceBytesDownloaded"] = "piece_bytes_downloaded";
    Events["PieceBytesUploaded"] = "piece_bytes_uploaded";
})(Events || (Events = {}));
